import { Typography } from '@material-ui/core'

import { getTranslate } from '../../../localization'
import useStyles from './styles/ReservationNumbersModalTableHead.styles'

const ReservationNumbersModalTableHead = () => {
  const classes = useStyles()
  return (
    <div className={classes.tableHead}>
      <Typography variant="body1">{getTranslate('#')}</Typography>
      <Typography variant="body1">
        {getTranslate('Reservation Number')}
      </Typography>
      <Typography variant="body1">{getTranslate('Date')}</Typography>
      <Typography variant="body1">{getTranslate('Type')}</Typography>
    </div>
  )
}
export default ReservationNumbersModalTableHead
